import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { IStyledFieldProps } from "../../../../components/parts/styled-field/styled-input-field"
import { RegisterFromEmailInput } from "../../../../rpcs/dist/UserRPC"

export const FormId = "PasswordResetIndex"

export interface IFormField {
  email: string
}

export const formData: Array<IStyledFieldProps<
  keyof Pick<RegisterFromEmailInput, "email">
>> = [
  {
    name: "email",
    title: "メールアドレス",
    icon: faEnvelope,
    type: "email",
    placeholder: "メールアドレス",
  },
]
